/*eslint-disable */
import React, { Component } from "react";
import RequestsHeader from "./requestHeaders";
import FilterHeader from "./filterHeaders";
import { readOrderDispatcher } from "../../redux/actions/allOrdersAction";
import { connect } from "react-redux";
import ReadAxios from "../../components/axiosComponent/read";
import OrderAgGridTable from "../../components/common/orderadGridTable";
import FormikReject from "./modalReject";
import ClubBooking from "./clubBooking";
import BookingGenerateOrderButton from "./bookingGenerateOrderModal";
import CancelBooking from "./cancelBooking";
import { translate } from "react-i18next";
import { filter, isEmpty } from "lodash";
import { Grid, Pagination, Dropdown, Button, Loader } from "semantic-ui-react";
import moment from "moment";
import Vehicletyperenderer from "../common/vehicletyperenderer";
import Sourcerender from "../common/sourcerender";
import Destinationrender from "../common/destinationrender";
import Allotmentrender from "../common/allotmentrender";
import ViewDetails from "../common/viewDetails";
import ViewDetailDelivery from "../common/viewDetailDelivery";
import ViewPlanningDetails from "../common/viewPlanningDetails";
import EditDeleteDetails from "../common/editDeleteDetails";
import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";
import allAxiosCommonTA from "../axiosComponent/allAxiosCommonTA";
import ModalOrderDetails from "./modalOrderDetails";
import ModalDeliveryDetails from "./modalDeliveryDetails";
import ModalPlanningDetails from "./modalPlanningDetails";
import ExportPDF from "../../components/axiosComponent/exportPDF";
import { FEATURES } from "../../utils/constant";
import cogoToast from "cogo-toast";

class Requests extends Component {
  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      spinnerLoading: false,
      loadingData: true,
      isTableLoading:true,
      generated_order: false,
      club: false,
      prevProps: [],
      OrderLists: "",
      rowData: [],
      locales: props.locales.local,
      paginationCallbackData: [],
      chunkedRowData: [],
      currentPageData: [],
      selectedRows: [],
      currentPageNumber: -1,
      componentRenderKey: 0,
      viewModeData: [],
      viewDeliveryData: [],
      ordersFromBooking: [],
      openViewDetails: false,
      openDetailsOrder: false,
      openGenerateOrder: false,
      requiredVehicleType: [],
      movementTypeSet: "primary",
      userStatistic: {},
      openDetailsPlanning: false,
      currentPage: 1,
      totalPages: null,
      viewPlanningData: [],
      bookingIDClicked: 0,
      handleSearch: "",
      orderData: [],
      containerType: [
        { key: "1", text: "20 Feet", value: "FT20" },
        { key: "2", text: "40 Feet", value: "FT40" },
      ],
      querySelected: "",
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  componentDidMount() {
    // this.props.read();
    if (this.props.location?.state?.filterProp?.typeFrom === "planning") {
      this.requiredVehicleTypeList();
      this.bookingWithFilterAPICall(this.props.location?.state.filterProp);
    } else {
      this.domesticAPICall();
      this.requiredVehicleTypeList();
    }
  }

  handleSearchChange(data) {
    this.setState({ handleSearch: data });
  }

  bookingWithFilterAPICall(filterElements) {
    let searchIdFilter = "";
    if (filterElements?.booking_branch_id)
      searchIdFilter = searchIdFilter.concat(
        "&booking_branch_id=" + filterElements.booking_branch_id
      );
    if (filterElements?.billing_party_id)
      searchIdFilter = searchIdFilter.concat(
        "&billing_party_id=" + filterElements.billing_party_id
      );
    if (filterElements?.load_type_id)
      searchIdFilter = searchIdFilter.concat(
        "&load_type_id=" + filterElements.load_type_id
      );
    if (filterElements?.vehicle_type_id)
      searchIdFilter = searchIdFilter.concat(
        "&vehicle_type_id=" + filterElements.vehicle_type_id
      );

    let filterList = filterElements.filter_type.toString();

    allAxiosCommonTA({
      url: "/bookings/primary",
      method: "get",
      getValues:
        `filter_type=${filterList}` +
        `${searchIdFilter}` +
        `&pickup_date=${filterElements.booking_date}&`,
    })
      .then((response) => {
        this.setState({
          loadingData: false,
          rowData: response.data.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  domesticAPICall() {
    allAxiosCommonTA({
      url: "/bookings/primary",
      method: "get",
      getValues: `${this.state.querySelected}&page=${this.state.currentPage}&limit=10&`,
    })
      .then((response) => {
        this.setState(
          {
            loadingData: false,
          isTableLoading: false,
            rowData: response.data.data,
          },
          () => {
            this.setState({ totalPages: response.data.meta.totalPages });
          }
        );
        this.getUserStatistics("primary");
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  secondaryAPICall() {
    allAxiosCommonTA({
      url: "/bookings/secondary",
      method: "get",
      getValues: `${this.state.querySelected}&page=${this.state.currentPage}&limit=10&`,
    })
      .then((response) => {
        this.setState(
          {
            loadingData: false,
          isTableLoading: false,
            rowData: response.data.data,
          },
          () => {
            this.setState({ totalPages: response.data.meta.totalPages });
          }
        );
        this.getUserStatistics("primary");
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  importAPICall() {
    allAxiosCommonTA({
      url: "/bookings/import",
      method: "get",
      getValues: `${this.state.querySelected}&page=${this.state.currentPage}&limit=10&`,
    })
      .then((response) => {
        this.setState(
          {
            loadingData: false,
          isTableLoading: false,
            isTableLoading: false,
            rowData: response.data.data,
          },
          () => {
            this.setState({ totalPages: response.data.meta.totalPages });
          }
        );
        this.getUserStatistics("import");
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  exportAPICall() {
    allAxiosCommonTA({
      url: "/bookings/export",
      method: "get",
      getValues: `${this.state.querySelected}&page=${this.state.currentPage}&limit=10&`,
    })
      .then((response) => {
        this.setState(
          {
            loadingData: false,
          isTableLoading: false,
            rowData: response.data.data,
          },
          () => {
            this.setState({ totalPages: response.data.meta.totalPages });
          }
        );
        this.getUserStatistics("export");
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  requiredVehicleTypeList = () => {
    allAxiosCommonRequest({ url: "/masters/vehicleTypeMaster", method: "post" })
      .then((response) => {
        let tempN = response.data.resultSet;
        let options = [];
        if (response.data.resultSet.length > 0) {
          response.data.resultSet.map((object, index) => {
            let temp = {};
            temp.key = object.vehicleTypeId;
            temp.text = object.vehicleType;
            temp.value = object.vehicleTypeId;
            temp.raw = { ...object };
            return (options[index] = temp);
          });
        }
        this.setState({
          requiredVehicleType: options,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  onCellClicked = (rowData) => {
    typeof rowData.value != "undefined" && this.onRowEdit(rowData.data);
  };

  onRowEdit = (rowData) => {
    this.props.history.push({
      pathname: "/edit-booking-request",
      state: { item: { ...rowData.shipment } },
      // search: `?shipmentId=${rowData.shipment.vendor_shipment_id}`,
    });
  };

  clearSelectedRows = () => {
    this.setState({ selectedRows: [] });
    window.location.reload()
  };

  handleSelect = (data) => {
    console.log("vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv");
    let selectedrows = data.api.getSelectedRows();
    console.log(selectedrows);
    if (selectedrows.length > 0) {
      let dataSet = [...this.state.selectedRows, ...selectedrows];
      console.log("dataSetdataSetdataSetdataSetdataSetdataSet");
      console.log(data);
      console.log(dataSet);
      /* let dataFilter = dataSet.filter((value, index, self) => {
        console.log("vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv");
        console.log(value);
        //return self.findIndex((v) => v.booking_id === value.booking_id) === index;
      }); */

      /* let dataFilter = dataSet.filter(
        (item, index) => dataSet.indexOf(item) === index
      ); */

      let dataFilter = dataSet.filter((value, index, self) => {
        return (
          self.findIndex((v) => v.booking_id === value.booking_id) === index
        );
      });

      console.log("GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGg");
      console.log(dataFilter);
      this.setState({ selectedRows: dataFilter });
    }
  };

  getRowDetails = (data) => {
    this.setState({ viewModeData: data }, () => {
      this.setState({ openViewDetails: true });
    });
    allAxiosCommonTA({
      url: "/bookings/" + data.booking_id + "/getOrders",
      method: "get",
    })
      .then((response) => {
        this.setState({ ordersFromBooking: response.data.data });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  getDeliveryDetails = (data) => {
    this.setState({ viewModeData: data }, () => {
      this.setState({ orderData: data });
      this.setState({ openDetailsOrder: true });
    });
    allAxiosCommonTA({
      url: "/bookings/" + data.booking_id + "/deliveries",
      method: "get",
    })
      .then((response) => {
        this.setState({ viewDeliveryData: response.data.data });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  getPlanningDetails = (data) => {
    console.log(data);
    this.setState({
      viewPlanningData: data,
      bookingIDClicked: data.booking_id,
    });

    this.setState({ openDetailsPlanning: true }, () => {
      console.log(data);
    });
  };

  getEditDetails = (data) => {
    this.props.history.push({ pathname: "/edit-booking-request", state: data });
  };

  handleViewDetailClose = (data) => {
    this.setState({ openViewDetails: false });
  };
  handleDetailOrderClose = (data) => {
    this.setState({ openDetailsOrder: false });
  };
  handlePlanningOrderClose = (data) => {
    this.setState({ openDetailsPlanning: false });
  };

  onTabChangeMovementType = (movementType) => {
    this.setState({ currentPage: 1, totalPages: null }, () => {
      if (movementType == "primary") {
        this.domesticAPICall();
        this.setState({ movementTypeSet: "primary" });
      } else if (movementType == "secondary") {
        this.secondaryAPICall();
        this.setState({ movementTypeSet: "secondary" });
      } else if (movementType == "import") {
        this.importAPICall();
        this.setState({ movementTypeSet: "import" });
      } else if (movementType == "export") {
        this.exportAPICall();
        this.setState({ movementTypeSet: "export" });
      }
    });
  };

  getUserStatistics = (movemenType) => {
    allAxiosCommonTA({
      url: "/bookings/" + movemenType + "/status/statistics",
      method: "get",
    })
      .then((response) => {
        this.setState({ userStatistic: response.data.statusCount });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  callSearchHandleAPI = (queryString) => {
    this.setState({ querySelected: queryString });
    allAxiosCommonTA({
      url: "/bookings/" + this.state.movementTypeSet,
      method: "get",
      getValues: queryString + `page=${this.state.currentPage}&limit=10&`,
    })
      .then((response) => {
        this.setState(
          {
            loadingData: false,
          isTableLoading: false,
            rowData: response.data.data,
          },
          () => {
            this.setState({ totalPages: response.data.meta.totalPages });
          }
        );
        this.getUserStatistics(movemenType);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  exportTableData = (
    data,
    newStatus,
    booking_branch,
    pickupOn,
    bookingNo,
    loadTypeSelected,
    billingBranchSelected,
    vehicleType
  ) => {
    this.setState({ spinnerLoading: true });
    const booking_branch_id = booking_branch ? booking_branch : "";
    const booking_number = bookingNo ? bookingNo : "";
    const pickup_date = pickupOn ? pickupOn : "";
    const billing_party_id = billingBranchSelected ? billingBranchSelected : "";
    const load_type_id = loadTypeSelected ? loadTypeSelected : "";
    const vehicle_type_id = vehicleType ? vehicleType : "";
    const status = newStatus ? newStatus : "";

    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/bookings/excel/export?movement_type=${this.state.movementTypeSet}&ag_grid_fields=${data}&status=${status}&booking_branch_id=${booking_branch_id}&booking_number=${booking_number}&pickup_date=${pickup_date}&billing_party_id=${billing_party_id}&load_type_id=${load_type_id}&vehicle_type_id=${vehicle_type_id}&`
    }).then((res)=>{
      if(res?.data?.status == 1){
        cogoToast.success(res?.data?.message || "Export has initiated,please find the status in downloads section", {position : "top-right"});
      }else{
        cogoToast.error(res?.data?.message || "Failed to export data", {position : "top-right"});
      }
      this.setState({ spinnerLoading: false });
    }).catch((err)=>{
      this.setState({ spinnerLoading: false });
    })
  };

  handlePaginationChange = (e, { activePage }) => {
    let payload = this.state.payload;
    this.setState({ currentPage: activePage }, () => {
      if (this.state.movementTypeSet == "primary") {
        this.domesticAPICall();
      } else if (this.state.movementTypeSet == "import") {
        this.importAPICall();
      } else if (this.state.movementTypeSet == "export") {
        this.exportAPICall();
      }
    });
  };
  render() {
    const { t } = this.props;
    const { rowData, generated_order, OrderLists } = this.state;

    const columnDefsDomestic = [
      {
        headerName: "Booking No",
        field: "booking_number",
        sortable: true,
        filter: true,
        /*  headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true, */
        checkboxSelection: (params) => {
          if (
             FEATURES.RestrictGenerateOrderFromBookings(params?.data?.status)
          )
            return false;
          else return true;
        },
        cellClass: (params) => {
          return FEATURES.RestrictGenerateOrderFromBookings(params?.data?.status)
            ? "padding-left-40"
            : "padding-left-0";
        },
        tooltipField: "booking_number",
        /*  enableRowGroup: true,
        enablePivot: true, */
        width: 200,
        pinned: "left",
      },
      {
        headerName: "Booking Date & Time",
        field: "booking_date",
        sortable: true,
        filter: true,
        /* valueFormatter: function (params) {
          return moment(params.value).format("DD-MM-yyyy");
        }, */
      },
      {
        headerName: "Requested Pickup Date",
        field: "booking_delivery.requested_pickup_date",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Requested Delivery Date",
        field: "booking_delivery.requested_delivery_date",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.status") || "Status",
        field: "status", // vehicle_type
        sortable: true,
        /* cellRenderer: "allotment", */
        filter: true,
      },
      {
        headerName: "Booking Branch",
        field: "booking_branch", // source
        /* cellRenderer: "sourcerender", */
        sortable: true,
        filter: true,
        /* valueFormatter: function (params) {
          return moment(params.value).format("DD-MM-yyyy");
        }, */
      },
      {
        headerName: "Origin",
        field: "source", // source
        /*         cellRenderer: "sourcerender", */
        sortable: true,
        filter: true,
      },
      {
        headerName: "Destination",
        field: "destination", // destination
        /* cellRenderer: "destinationrender", */
        sortable: true,
        filter: true,
      },
      //DO NUMBER
      {
        headerName:
          this.state.movementTypeSet == "export" ? "DO Number" : "CRO Number",
        field: "booking_delivery.DO_number", // vehicle_type
        sortable: true,
        /* cellRenderer: "allotment", */
        hide:
          this.state.movementTypeSet == "export" ||
          this.state.movementTypeSet == "import"
            ? false
            : true,
      },
      {
        headerName: "Total Vehicles",
        field: "no_of_vehicles", // vehicle_type
        sortable: true,
        //cellRenderer: "vehicletyperenderer",
        filter: true,
        hide: this.state.movementTypeSet == "primary" ? false : true,
      },
      {
        headerName: "Pending Vehicles",
        field: "pending_vehicles", // vehicle_type
        sortable: true,
        //cellRenderer: "vehicletyperenderer",
        filter: true,
        hide: this.state.movementTypeSet == "primary" ? false : true,
      },

      {
        headerName: "Total Container",
        field: "no_of_vehicles", // vehicle_type
        //field: "no_of_containers", // vehicle_type
        sortable: true,
        /* cellRenderer: "allotment", */
        hide: this.state.movementTypeSet != "primary" ? false : true,
      },
      {
        headerName: "Pending Containers",
        field: "pending_vehicles",
        //field: "pending_containers", // vehicle_type
        sortable: true,
        /* cellRenderer: "allotment", */
        hide: this.state.movementTypeSet != "primary" ? false : true,
      },

      {
        headerName: t("table_view.gross_weight") || "Gross Weight",
        field: "gross_weight",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Billing Party",
        field: "booking_delivery.billing_party_name",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Consignee Name",
        field: "booking_delivery.consignee_name",
        sortable: true,
        filter: true,
        hide: this.state.movementTypeSet == "primary" ? false : true,
      },
      {
        headerName: "Created By",
        field: "created_by",
        sortable: true,
        filter: true,
        hide: this.state.movementTypeSet == "primary" ? false : true,
      },
      {
        headerName: "Created On",
        field: "created_on",
        sortable: true,
        filter: true,
        hide: this.state.movementTypeSet == "primary" ? false : true,
      },
      {
        headerName: "Delivery location Name",
        field: "booking_delivery.consignee_name",
        sortable: true,
        filter: true,
        hide: this.state.movementTypeSet == "import" ? false : true,
      },
      {
        headerName: "Port terminal Name",
        field: "booking_delivery.consignee_name",
        sortable: true,
        filter: true,
        hide: this.state.movementTypeSet == "export" ? false : true,
      },
      {
        headerName: "Consignor Name",
        field: "booking_delivery.consignor_name",
        sortable: true,
        filter: true,
        hide: this.state.movementTypeSet == "primary" ? false : true,
      },
      {
        headerName: "Port Terminal",
        field: "booking_delivery.consignor_name", // vehicle_type
        sortable: true,
        /* cellRenderer: "allotment", */
        hide: this.state.movementTypeSet == "import" ? false : true,
      },
      {
        headerName: "Stuffing Location",
        field: "booking_delivery.consignor_name", // vehicle_type
        sortable: true,
        /* cellRenderer: "allotment", */
        hide: this.state.movementTypeSet == "export" ? false : true,
      },
      {
        headerName: "Shipping Line",
        field: "booking_delivery.shipping_line_name", // vehicle_type
        sortable: true,
        /* cellRenderer: "allotment", */
        hide: this.state.movementTypeSet != "primary" ? false : true,
      },
      {
        headerName: "Delivery",
        field: "edit",
        cellRenderer: "ViewDetailDelivery",
        suppressToolPanel: true,
        pinned: "right",
        width: 120,
        minWidth: 120,
        maxWidth: 120,
      },
      {
        headerName: "Orders",
        field: "edit",
        cellRenderer: "ViewDetails",
        suppressToolPanel: true,
        pinned: "right",
        width: 120,
        minWidth: 120,
        maxWidth: 120,
      },
      {
        headerName: "Planning",
        field: "edit",
        cellRenderer: "ViewPlanningDetails",
        suppressToolPanel: true,
        pinned: "right",
        width: 120,
        minWidth: 120,
        maxWidth: 120,
      },
      {
        headerName: "Action",
        field: "edit_delete",
        cellRenderer: "EditDeleteDetails",
        suppressToolPanel: true,
        pinned: "right",
        width: 120,
        minWidth: 120,
        maxWidth: 120,
      },
      //{ headerName: 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', width: 280, suppressToolPanel: true }
    ];

    var frameworkcomponent = {
      vehicletyperenderer: Vehicletyperenderer,
      sourcerender: Sourcerender,
      destinationrender: Destinationrender,
      allotment: Allotmentrender,
      ViewDetails: ViewDetails,
      ViewDetailDelivery: ViewDetailDelivery,
      EditDeleteDetails: EditDeleteDetails,
      ViewPlanningDetails: ViewPlanningDetails,
    };

    let rowValue = [];

    rowData &&
      rowData.forEach((object, index) => {
        let temp = {};
        temp = object;

        temp.booking_number = object?.booking_number || "NA";
        temp.booking_date = object?.booking_date || "NA";
        temp.status = object?.status || "NA";
        temp.booking_branch = object?.booking_branch || "NA";
        temp.source = object?.source || "NA";
        temp.destination = object?.destination || "NA";
        temp.created_on = object?.created_on || "NA";
        temp.created_by = object?.created_by || "NA";
        temp.no_of_vehicles = object?.no_of_vehicles || "NA";
        temp.pending_vehicles = object?.pending_vehicles || "NA";
        temp.gross_weight = object?.gross_weight || "NA";
        if (object?.booking_delivery) {
          temp.booking_delivery.DO_number =
            object?.booking_delivery?.DO_number || "NA";
          temp.booking_delivery.billing_party_name =
            object?.booking_delivery?.billing_party_name || "NA";
          temp.booking_delivery.consignee_name = object?.booking_delivery
            ?.consignee_name
            ? object.booking_delivery.consignee_name
            : "NA";
          temp.booking_delivery.consignor_name = object?.booking_delivery
            ?.consignor_name
            ? object.booking_delivery.consignor_name
            : "NA";
          temp.booking_delivery.shipping_line_name =
            object?.booking_delivery?.shipping_line_name || "NA";
          temp.booking_delivery.requested_delivery_date =
            object?.booking_delivery?.requested_delivery_date || "NA";
          temp.booking_delivery.requested_pickup_date =
            object?.booking_delivery?.requested_pickup_date || "NA";
        }

        rowValue[index] = temp;
      });

    return (
      <React.Fragment>
        <RequestsHeader
          isLoading={this.state.spinnerLoading}
          title={
            +localStorage.getItem("customerNumber") == 1158
              ? "Indents"
              : +localStorage.getItem("customerNumber") == 503
              ? "Orders"
              : "Bookings"
          }
          LinkName="/create-booking-request"
          onTabChangeMovementType={this.onTabChangeMovementType}
          exportTableData={this.exportTableData}
          movementType={this.state.movementTypeSet}
          handleSearchChange={this.handleSearchChange}
          callSearchHandleAPI={this.callSearchHandleAPI}
        />
        <FilterHeader userStatistic={this.state.userStatistic} />
        <div className="pb-5 booking-request-ag-grid">
        {this.state.isTableLoading ? (
            <div className="spinner-container">
              <Loader active inline="centered" />
            </div>
          ) : (
            <>
              <OrderAgGridTable
                columnDefs={columnDefsDomestic}
                pagination={false}
                titleBarTitle="Delivery Plan"
                baseURL={"orders"}
                extracomponents={frameworkcomponent}
                rowData={rowValue}
                suppressRowClickSelection={true}
                enableCellChangeFlash={true}
                keyIndex={"u_id"}
                onEdit={this.onRowEdit}
                getRowDetails={this.getRowDetails}
                getEditDetails={this.getEditDetails}
                handleSearchData={this.state.handleSearch}
                /* cellDoubleClicked={this.onCellClicked} */
                onSelectionChanged={this.handleSelect}
                defaultSelectedRows={this.state.selectedRows}
                getDeliveryDetails={this.getDeliveryDetails}
                getPlanningDetails={this.getPlanningDetails}
                showFilter={false}
              />
              <ModalOrderDetails
                modalOpen={this.state.openViewDetails}
                handleClose={this.handleViewDetailClose}
                viewModeData={this.state.ordersFromBooking}
              ></ModalOrderDetails>
              <ModalDeliveryDetails
                movementType={this.state.movementTypeSet}
                modalOpen={this.state.openDetailsOrder}
                handleClose={this.handleDetailOrderClose}
                viewModeData={this.state.viewDeliveryData}
                deliveryDetails={this.state.viewDeliveryData}
                orderDetail={this.state.orderData}
              ></ModalDeliveryDetails>
              <ModalPlanningDetails
                modalOpen={this.state.openDetailsPlanning}
                handleClose={this.handlePlanningOrderClose}
                viewPlanningData={this.state.viewPlanningData}
                bookingIDClicked={this.state.bookingIDClicked}
                auth={this.props.auth}
              ></ModalPlanningDetails>

              <div className="life-cycle w3-white ui pagination menu"
                style={this.state.selectedRows.length > 0 ?
                  { marginBottom: "50px", } :
                  {}
                }>
                <Pagination
                  defaultActivePage={this.state.currentPage}
                  firstItem={null}
                  lastItem={null}
                  onPageChange={this.handlePaginationChange}
                  pointing
                  secondary
                  totalPages={this.state.totalPages}
                />
                {/* <Dropdown
              size="mini"
              className="m-1"
              placeholder='10'
              selection
              defaultValue={'10'}
              onChange={this.handlePagination}
              compact
              options={itemsInOnePage}
            /> */}
              </div>
            </>
          )}
        </div>

        {this.props.auth.role == "Quality Control" ? null : (
          <>
            {this.state.selectedRows.length > 0 ? (
              <div className="life-cycle w3-white p-2">
                <Grid columns={2} className="ml-2">
                  <Grid.Row>
                    <ClubBooking
                      booking={this.state.selectedRows}
                      requiredVehicleType={this.state.requiredVehicleType}
                      // reFetchOrder={this.fetchOrderDetails}
                    />

                    <BookingGenerateOrderButton
                      movementType={this.state.movementTypeSet}
                      orders={this.state.selectedRows}
                      reFetchOrder={this.reloadCurrentPage}
                      shipmentId={this.props.shipmentId}
                      modalOpen={this.state.openGenerateOrder}
                      handleClose={this.state.openGenerateOrder}
                      requiredVehicleType={this.state.requiredVehicleType}
                      requiredContainerType={this.state.containerType}
                      rowSelected={this.state.selectedRows.length}
                    />

                    <CancelBooking
                      movementType={this.state.movementTypeSet}
                      orders={this.state.selectedRows}
                      reFetchOrder={this.reloadCurrentPage}
                      shipmentId={this.props.shipmentId}
                      modalOpen={this.state.openGenerateOrder}
                      handleClose={this.state.openGenerateOrder}
                      requiredVehicleType={this.state.requiredVehicleType}
                    />

                    <Button
                      type="button"
                      onClick={this.clearSelectedRows}
                      size="mini"
                      color="red"
                      className=" m-2 w3-hover-red"
                      circular
                    >
                      {"Clear Selected Rows"}
                    </Button>

                    {/* <FormikReject
                      orders={this.state.selectedRows}
                      reFetchOrder={this.reloadCurrentPage}
                      shipmentId={this.props.shipmentId}
                    /> */}
                  </Grid.Row>
                </Grid>
              </div>
            ) : null}
          </>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ allorders, locales, auth }) => {
  return {
    allorders,
    auth,
    locales,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    read: () => dispatch(readOrderDispatcher()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("orders")(Requests));
